import { HStack, Icon } from "@chakra-ui/react";
import { FiRefreshCw } from "react-icons/fi";
import CDS from "design-system";
import { PrefixId } from "features/Resources/Shared/models";
import { useForceSendByPrefixId, useSkipByPrefixId } from "features/Resources/Shared/hooks";

interface FailedActionHeaderButtonsProps {
  prefixId: PrefixId;
}

/**
 * Primary recovery actions surfaced in the header when an action has failed.
 * Mirrors the Task pattern (Skip + primary CTA) — the underlying mutations are
 * the same `force` / `skip` endpoints used by the three-dot menu, but failed
 * state deserves explicit affordance instead of being hidden behind a menu.
 */
export default function FailedActionHeaderButtons({ prefixId }: FailedActionHeaderButtonsProps) {
  const { mutate: skip, isPending: skipping } = useSkipByPrefixId(prefixId);
  const { mutate: retry, isPending: retrying } = useForceSendByPrefixId(prefixId);

  return (
    <HStack spacing={2}>
      <CDS.Button
        intent={CDS.Button.intent.secondary}
        variant={CDS.Button.variant.outline}
        size="sm"
        onClick={() => skip()}
        disabled={skipping || retrying}
      >
        Skip
      </CDS.Button>
      <CDS.Button
        intent={CDS.Button.intent.primary}
        variant={CDS.Button.variant.solid}
        size="sm"
        onClick={() => retry()}
        loading={retrying}
        disabled={skipping || retrying}
        leftIcon={{ customIcon: <Icon as={FiRefreshCw} /> }}
      >
        Retry
      </CDS.Button>
    </HStack>
  );
}
